import { appElId } from '../constants';
import { icons } from '../icons';
import { IMenuData, navStore } from '../store';
import { addCustomElement } from '../utils';
import { StoredOffer } from './types';

const componentLevelCSSPrefix = `${appElId}__thumb-bar__offer-nav`;

export class ThumbOfferNav extends HTMLElement {
    _offer: StoredOffer | undefined = undefined;

    constructor() {
        super();
    }

    connectedCallback() {
        const { vin, activeTab } = this.dataset;

        if (!vin) {
            console.warn('No vin provided to component, unable to render');
            this.innerHTML = '';
            return;
        }

        const { storedOffers } = navStore.getState() as IMenuData;
        this._offer = storedOffers.find(offer => offer.vin === vin);

        if (!this._offer) {
            console.warn(`Unable to find offer for vin: ${vin} in store, unable to render`);
            this.innerHTML = '';
            return;
        }

        const YMM = `${this._offer.vehicleInformation.profile.year} ${this._offer.vehicleInformation.profile.make} ${this._offer.vehicleInformation.profile.model}`;
        let expirationDate = new Date(this._offer.expirationDateUtc);
        // expirationDateUtc is the time it expires. We show the last day it's not expired.
        expirationDate.setDate(expirationDate.getDate() - 1);

        const vehicleMakeUrl = this._offer.vehicleInformation.profile.make.replace(/\s+/g, '-').toLowerCase();
        const vehicleModelUrl = this._offer.vehicleInformation.profile.model
            .replace(/&/g, 'and')
            .replace(/\s+/g, '-')
            .toLowerCase();
        const imageUrl = `https://img2.carmax.com/assets/mmy-${encodeURIComponent(vehicleMakeUrl)}-${encodeURIComponent(
            vehicleModelUrl
        )}-${encodeURIComponent(this._offer.vehicleInformation.profile.year)}/image/1.jpg`;

        const analyticsKey = `Header${activeTab ? `-${activeTab}` : ''}`;

        this.innerHTML = `
        <a href="/sell-my-car/offers/${
            this._offer.offerCode
        }?originPage=${analyticsKey}" data-kmx-analytics="prop5=${analyticsKey}">
            <div class="${componentLevelCSSPrefix}">
                <div class="image-container">
                    <img class="offer-image" src="${imageUrl}">
                </div>
                <div class="offer-container">
                    <p class="header">${YMM.trim()}</p>
                    <p class="caption">$${Intl.NumberFormat().format(
                        this._offer.offerAmount
                    )} • Expires: ${expirationDate.toLocaleString('default', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        })}</p>
                </div>
                <div class="arrow-container">
                    ${atob(icons.rightArrow)}
                </div>
            </div>
        </a>
        `;
    }

    disconnectedCallback() {}
}

const KMX_THUMB_OFFER_NAV = 'kmx-thumb-offer-nav';

addCustomElement(KMX_THUMB_OFFER_NAV, ThumbOfferNav);
